module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bodyC"
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('img', {
    staticClass: "png",
    attrs: {
      "src": require("../../../static/img/404.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "png msg",
    attrs: {
      "src": require("../../../static/img/404_msg.png")
    }
  }), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('img', {
    staticClass: "png",
    attrs: {
      "src": require("../../../static/img/404_to_index.png")
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "png",
    attrs: {
      "id": "cloud"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-369bf519","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/component/notFind.vue
// module id = 1209
// module chunks = 2